import styled from 'styled-components';

export const ProjectItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  img {
    width: 60px;
    height: 60px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
  }
`;

export const ProgressBar = styled.div`
  height: 18px;
  width: 100%;
  border-radius: 30px;
  background: ${({ theme }) => theme.colors.grayLight2};
  margin: 10px 0 4px;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    border-radius: 30px;
    height: 18px;
    width: ${({ progress }) => progress > 100 ? 100 : progress}%;
    background: ${({ theme }) => theme.colors.primary};
  }
`;

export const FundraisingItem = styled.div`
  display: flex;
  flex-direction: column;

  > div:first-of-type, div:last-of-type {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
